import { render, staticRenderFns } from "./RouteItemMap.vue?vue&type=template&id=3a5c5492"
import script from "./RouteItemMap.vue?vue&type=script&lang=js"
export * from "./RouteItemMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports